import dynamic from 'next/dynamic';

export default dynamic(() => import('./DatePickerInternal'), { ssr: false });
